export default __webpack_public_path__ + "static/media/shadowoverlay.d0fc4408.png";